var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutgoing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2266_105950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.475 10.9438C14.3644 11.7878 13.9511 12.5629 13.312 13.1251C12.6728 13.6872 11.8512 13.9981 11 14C6.0375 14 2 9.96251 2 5.00001C2.00188 4.14879 2.3128 3.32722 2.87495 2.68804C3.43711 2.04886 4.21225 1.63557 5.05625 1.525C5.2714 1.50115 5.48856 1.54645 5.67624 1.65433C5.86391 1.76222 6.01234 1.92708 6.1 2.125L7.35625 5.05626C7.42141 5.20841 7.44754 5.37442 7.43226 5.53923C7.41698 5.70404 7.36078 5.86243 7.26875 6L6.23125 7.5875C6.70105 8.54094 7.47516 9.31064 8.43125 9.775L10 8.73125C10.1374 8.63861 10.2962 8.58254 10.4613 8.56832C10.6265 8.5541 10.7925 8.58222 10.9438 8.65L13.875 9.9C14.0729 9.98767 14.2378 10.1361 14.3457 10.3238C14.4536 10.5114 14.4989 10.7286 14.475 10.9438ZM10 6.5C10.1325 6.4982 10.2596 6.44693 10.3562 6.35625L12.5 4.20626V5.50001C12.5 5.63261 12.5527 5.75979 12.6464 5.85356C12.7402 5.94733 12.8674 6 13 6C13.1326 6 13.2598 5.94733 13.3536 5.85356C13.4473 5.75979 13.5 5.63261 13.5 5.50001V3.00001C13.5 2.8674 13.4473 2.74022 13.3536 2.64645C13.2598 2.55268 13.1326 2.5 13 2.5H10.5C10.3674 2.5 10.2402 2.55268 10.1464 2.64645C10.0527 2.74022 10 2.8674 10 3.00001C10 3.13261 10.0527 3.25979 10.1464 3.35356C10.2402 3.44733 10.3674 3.50001 10.5 3.50001H11.7937L9.64375 5.64375C9.54986 5.73855 9.49719 5.86658 9.49719 6C9.49719 6.13343 9.54986 6.26146 9.64375 6.35625C9.74041 6.44693 9.86748 6.4982 10 6.5Z",
    fill: "#849291"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2266_105950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutgoing);
export default __webpack_public_path__ + "static/media/outgoing.5d5f54615955a2d28df2e589f8f05e71.svg";
export { ForwardRef as ReactComponent };